export function filterByChildren({ children }, search) {
  return children.toLowerCase().includes(search.toLowerCase())
}
